module.exports = __webpack_public_path__ + "img/symbol_2.d05cc092.png";